import { ProfileOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import { Badge, Button, Tooltip } from 'antd';
import React from 'react';
import { getLatestFamsSystemChangelog } from '@/services/bff/system-changelog.api';
import { hasUnreadSystemChangelog, readSystemChangelogLastSeen } from './seen';
import '@/pages/fams/system-changelog/index.less';

const CHANGELOG_PATH = '/data-management/system-changelog';

export const ChangelogTrigger: React.FC = () => {
  const [unread, setUnread] = React.useState(false);

  const refreshUnread = React.useCallback(async () => {
    try {
      const latest = await getLatestFamsSystemChangelog();
      setUnread(hasUnreadSystemChangelog(latest?.publishedAt));
    } catch {
      setUnread(false);
    }
  }, []);

  React.useEffect(() => {
    void refreshUnread();
    const onSeen = () => {
      setUnread(hasUnreadSystemChangelog(readSystemChangelogLastSeen()));
      void refreshUnread();
    };
    window.addEventListener('fams-system-changelog-seen', onSeen);
    return () =>
      window.removeEventListener('fams-system-changelog-seen', onSeen);
  }, [refreshUnread]);

  return (
    <Tooltip title="系统更新日志">
      <Badge dot={unread} offset={[-4, 4]}>
        <Button
          type="text"
          className="fams-changelog-trigger"
          aria-label="打开系统更新日志"
          onClick={() => history.push(CHANGELOG_PATH)}
        >
          <span className="fams-changelog-trigger-icon" aria-hidden="true">
            <ProfileOutlined />
          </span>
        </Button>
      </Badge>
    </Tooltip>
  );
};
